/* eslint-disable array-bracket-newline, react-hooks/exhaustive-deps */
import { ITicker } from '@kattana-io/common';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTrendingItems, watchlistSelector } from '..';
import { actionRemoveWatchlist } from '../../../actions/watchlist';
import {
  formatMobileTableData,
  IMobileTableScema,
} from '../../../helpers/formatters';
import useGetWatchlistItems from '../useGetWatchlistItems';
import DailyPriceChangeMobile from './DailyPriceChange';
import TableCardMobile from '../../../molecules/Table/mobile/TableCard';
import { toFixed2 } from '../../DexTrades/formatters';
import { IMobileFilterProps } from '../../SearchTable/SearchTable';
import WhatchlistTickerMobile from './WatchlistTicker';
import { switchCurrentTicker } from '../../../Authlogic';

interface IWhatchlistTableMobileProps {
  inputSearch: string;
  onMount: (data: IMobileFilterProps) => void;
  onBack: () => void;
}

const WhatchlistTableMobile = ({
  inputSearch,
  onMount,
  onBack,
}: IWhatchlistTableMobileProps) => {
  const { current, watchlistItems, trending_items, trending_loading } =
    useSelector(watchlistSelector);

  const dispatch = useDispatch();
  const [sortedData, setSortedData] = useState<any>([]);
  // const hasAccount = !!account;
  const { trending_items_ids, trending_items_no_ids } =
    useTrendingItems(trending_items);

  // trending tickers
  const trending = useGetWatchlistItems(trending_items_ids.join(','));

  const { collection, searchedSortedData } = useMemo(() => {
    const collection = watchlistItems?.filter((item) =>
      item.name.toLocaleLowerCase().includes(inputSearch.toLocaleLowerCase())
    );

    const searchedSortedData = sortedData?.tickers?.filter((item: ITicker) =>
      item.name.toLocaleLowerCase().includes(inputSearch.toLocaleLowerCase())
    );
    return {
      collection,
      searchedSortedData,
    };
  }, [watchlistItems, inputSearch, sortedData]);

  useEffect(() => {
    onMount({
      setValue: setSortedData,
      initialData: {
        tickers: watchlistItems || [],
        selected: sortedData.selected,
      },
    });
  }, [onMount, setSortedData, watchlistItems]);

  // const onAccountRequired = useCallback(
  //   () => dispatch(actionShowModal(ModalTypes.connect, {})),
  //   [dispatch]
  // );

  const handleCardClick = useCallback(
    (payload: ITicker) => {
      switchCurrentTicker(payload);
      onBack();
    },
    [dispatch, onBack]
  );

  const onRemove = useCallback(
    (index: number) => dispatch(actionRemoveWatchlist(index)),
    [dispatch]
  );

  const schema1: IMobileTableScema = {
    row_1: {
      item_1: {
        accessor: 'label',
        parser: (value) => value,
      },
      item_2: {
        accessor: 'price',
        parser: (value) => `$${toFixed2(value)}`,
      },
    },
  };

  const schema2: IMobileTableScema = {
    row_1: {
      item_1: {
        accessor: 'pair',
        parser: (_, row) => (
          <WhatchlistTickerMobile ticker={row} active={current.id === row.id} />
        ),
      },
      item_2: {
        accessor: 'price',
        parser: (_, row) => {
          return <DailyPriceChangeMobile ticker={row} />;
        },
      },
    },
  };

  const schema3: IMobileTableScema = {
    row_1: {
      item_1: {
        accessor: 'pair',
        parser: (_, row) => (
          <WhatchlistTickerMobile
            ticker={row}
            actionRemoveWatchlist={onRemove}
            active={current.id === row.id}
          />
        ),
      },
      item_2: {
        accessor: 'price',
        parser: (_, row) => {
          return <DailyPriceChangeMobile ticker={row} />;
        },
      },
    },
  };

  const parsedData = ({
    data,
    hasId,
    hasUnfav,
  }: {
    data: any;
    hasId?: boolean;
    hasUnfav?: boolean;
  }) => {
    if (hasUnfav) {
      return formatMobileTableData({
        data,
        schema: schema3,
        getColorForItem: () => 'grey',
        handleCardClick,
        keyName: 'id',
      });
    }
    if (hasId) {
      return formatMobileTableData({
        data,
        schema: schema2,
        getColorForItem: () => 'grey',
        handleCardClick,
        keyName: 'id',
      });
    }
    return formatMobileTableData({
      data,
      schema: schema1,
      getColorForItem: () => 'grey',
    });
  };

  const data = searchedSortedData?.length > 0 ? searchedSortedData : collection;

  return (
    <>
      {parsedData({ data: trending_items_no_ids, hasId: false }).map(
        (row, index) => (
          <TableCardMobile key={index} data={{ ...row, opened: true }} />
        )
      )}
      {parsedData({ data: trending.items, hasId: true }).map((row) => (
        <TableCardMobile key={row.key} data={{ ...row, opened: true }} />
      ))}
      {parsedData({ data, hasUnfav: true }).map((row) => (
        <TableCardMobile key={row.key} data={{ ...row, opened: true }} />
      ))}
    </>
  );
};

export default WhatchlistTableMobile;
